import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { formatDifferenceFromNow } from 'src/utils/formatDifference'
import { BackToQueueModal } from '../BackToQueueModal/BackToQueueModal'
import { columns } from './AttendanceTab.columns'
import * as S from './AttendanceTab.styles'

export const AttendanceTab = ({ activeDocks, getActiveDocks }) => {
  const [showModal, setShowModal] = useState(false)
  const [receivement, setReceivement] = useState<any>(false)

  const statusDisabled = {
    2: 'RECEIVED',
    6: 'SALES_APPROVAL_FINISHED',
    9: 'FINISHED',
    99: 'CANCELED',
  }

  const checkIsButtonDisabled = (
    statusId: number,
  ) => Object.keys(statusDisabled).includes(statusId.toString())

  const createRowData = (dock) => {
    const startDate = dayjs(dock.activeReceivement?.dt_inicio_recebimento)

    return dock.activeReceivement
      ? {
        dock: dock.codigo,
        supplier: dock.activeReceivement.fornecedor.nm_fornecedor,
        startReceivement: startDate.format('DD/MM/YYYY H:mm'),
        time: formatDifferenceFromNow(startDate),
        options: (
          <S.Button
            disabled={checkIsButtonDisabled(dock.activeReceivement.id_status_recebimento)}
            title='Retornar para a fila'
            onClick={() => {
              setShowModal(true)
              setReceivement(dock.activeReceivement)
            }}
          >
            <S.BackToQueueButton
              aria-label={`Retornar recebimento ${dock.activeReceivement.id_recebimento} para a fila`}
            />
          </S.Button>
        ),
      }
      : { dock: dock.codigo, supplier: '** Livre **' }
  }

  const tableSize = useMemo(
    () => (activeDocks.length < 10 ? 10 : activeDocks.length), [activeDocks],
  )

  return (
    <S.Wrapper>
      <ReactTable
        style={{ height: '100%' }}
        data={activeDocks.map(createRowData)}
        showPagination={false}
        columns={columns as any}
        defaultPageSize={tableSize}
        pageSize={tableSize}
        className='-striped -highlight'
        previousText='Anterior'
        nextText='Próxima'
        loadingText='Carregando...'
        noDataText='Sem registros'
        pageText='Página'
        ofText='de'
        rowsText='Registros'
      />
      <BackToQueueModal
        receivement={receivement}
        showModal={showModal}
        setShowModal={setShowModal}
        setReceivement={setReceivement}
        getActiveDocks={getActiveDocks}
      />
    </S.Wrapper>
  )
}
